import { useTranslation } from "react-i18next";
import { useGetSubdivisionNamesForSelectLazyQuery } from "~/schemas/generated/graphql";
import { useEffect } from "react";
import { debounce, get } from "lodash";

export const onScrollBottomSubdivision = () => {
  const { t } = useTranslation();

  const [GetSubdivisionNamesForSelectQuery, { data, loading, fetchMore }] =
    useGetSubdivisionNamesForSelectLazyQuery({
      variables: {
        page: 0,
        count: 25,
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    });

  useEffect(() => {
    GetSubdivisionNamesForSelectQuery();
  }, []);

  const divisionsForSelect = [
    ...get(data, "SubdivisionGetter.get.items", []).map(({ id, name }) => {
      return {
        value: id,
        label: name,
      };
    }),
  ];

  const onScrollBottomDivisions = () => {
    if (divisionsForSelect.length < 25) {
      return;
    }
    const page = Math.ceil(divisionsForSelect.length / 25);
    fetchMore({
      variables: {
        page,
        count: 25,
      },
      updateQuery: ({ SubdivisionGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { SubdivisionGetter };
        }
        return {
          SubdivisionGetter: {
            ...SubdivisionGetter,
            get: {
              ...SubdivisionGetter.get,
              items: [
                ...SubdivisionGetter.get.items,
                ...get(fetchMoreResult, "SubdivisionGetter.get.items", []),
              ],
            },
          },
        };
      },
    });
  };

  const searchDivision = debounce((searchText: string) => {
    GetSubdivisionNamesForSelectQuery({
      variables: {
        page: 0,
        name: searchText,
      },
    });
  });

  return {
    divisionsForSelect,
    onScrollBottomDivisions,
    searchDivision,
    GetSubdivisionLoading: !!loading,
  };
};
